module.exports = __webpack_public_path__ + "img/37.fb1aaafa.png";